@if ((available?.length ?? 0) > 1) {
    @if (mode === "codes" || mode === "labels") {
        @for (item of available; track item) {
            <a
                href="#"
                (click)="onSelectLanguage($event, item)"
                [title]="item.label"
                [class.active]="active === item.id"
            >
                {{ mode === "codes" ? activeCode : item.label }}
            </a>
        }
    }

    @if (mode === "dropdown") {
        <p-select
            [options]="available"
            [(ngModel)]="active"
            optionLabel="label"
            optionValue="id"
            (onChange)="onChangeDropdown($event)"
        >
            <ng-template #selectedItem let-item>
                @if (item) {
                    <div
                        class="d-flex align-items-center justify-content-start"
                    >
                        <i
                            class="fa-solid fa-earth-americas fa-fw me-2 d-none d-lg-inline-block"
                        ></i>
                        <div class="d-none d-lg-block">{{ item?.label }}</div>
                        <div class="pb-1 d-lg-none text-uppercase">
                            {{ activeCode }}
                        </div>
                    </div>
                }
            </ng-template>

            <ng-template let-item #item>
                <div class="d-flex align-items-center justify-content-start">
                    @if (active === item.id) {
                        <i class="fas fa-check fa-fw me-1"></i>
                    }
                    @if (active !== item.id) {
                        <i class="fas fa-fw me-1"></i>
                    }
                    <div>{{ item.label }}</div>
                </div>
            </ng-template>
        </p-select>
    }
}
